export default __webpack_public_path__ + "static/media/VideoAvatar.d62f690b.png";